<template>
	<CardGrafico :subtitle="updatedAt">
		<template #grafico>
			<Loading v-if="series.length === 0" />
			<div
				v-else
				class="container__grafico__dispersao"
			>
				<slot name="action-buttons" />
				<Chart
					id="dispersao__parcelas"
					ref="ref__chart"
					:update-args="[chartOptions, true]"
					:options="chartOptions"
				/>

				<!-- <div style="display: flex; flex-direction: row; justify-content: space-evenly;">
          <div style="margin-left: 2rem">
            <i
              style="color:rgb(149, 187, 73); "
              class="fas fa-solid fa-circle"
            ></i> Estimado

            <i
              style="color:#d3d3d3;"
              class="fas fa-solid fa-circle"
            ></i> Real
          </div>

        </div> -->
			</div>
		</template>
	</CardGrafico>
</template>

<script>
import { Chart } from 'highcharts-vue'
import CardGrafico from '../CardGrafico/CardGrafico'
import Loading from '../../components/Loading/Loading'

// import _ from "lodash";

import { stringToExportCSV } from '../../utils/csvHellpers'

export default {
	components: { CardGrafico, Loading, Chart },
	props: {
		/**
		 * Dados que devem ir para o grafico
		 */
		infoGrafico: { type: Object },
		series: { type: Array, required: true },
		updatedAt: { type: String, required: false, default: '' },
	},
	data() {
		console.log('dados do grafico', this.series)
		return {
			dropdownTipoGrafico: 'vtcc',
			dropdownDownload: '',
			parcelasTemporarias: [],
			chartScopes: [
				{
					label: 'Altura Dominante',
					value: 'alturaDominante',
					acronimo: 'H_DOM',
					unidade: 'm',
				},
				{
					label: 'DAP Máximo',
					value: 'dapmaximo',
					acronimo: 'DAP_MAX',
					unidade: 'cm',
				},
				{
					label: 'Volume Individual com Casca',
					value: 'vicc',
					acronimo: 'VICC',
					unidade: 'm^3/fuste',
				},
				{
					label: 'Diâmetro Médio Quadrático',
					value: 'diametroMedio',
					acronimo: 'DG',
					unidade: 'cm',
				},
				{
					label: 'Incremento Médio Anual do VTCC',
					value: 'imavtcc',
					acronimo: 'IMA_VTCC',
					unidade: 'm^3/ha/ano',
				},
				{ label: 'VTCC', value: 'vtcc', acronimo: 'VTCC', unidade: 'm^3/ha' },
				{
					label: 'Área Basal',
					value: 'areaBasal',
					acronimo: 'AB',
					unidade: 'm^2/ha',
				},
			],
		}
	},
	computed: {
		/**
		 * Options para configuracao do grafico
		 */
		chartOptions() {
			return {
				chart: {
					type: 'scatter',
					zoomType: 'xy',
					// redraw: true
				},
				title: {
					text: this.$t('realEstimado'),

					style: {
						fontSize: '100%',
					},
				},
				subtitle: {
					text: '',
				},
				xAxis: {
					title: {
						enabled: true,
						text: this.$t('idadeMeses'),
						style: {
							fontSize: '100%',
						},
					},

					startOnTick: true,
					endOnTick: true,
					showLastLabel: true,
				},
				yAxis: {
					title: {
						text: this.infoGrafico.label + ' ' + this.infoGrafico?.unidade,
						style: {
							fontSize: '100% ',
						},
					},
				},
				legend: {
					enable: false,
				},
				plotOptions: {
					scatter: {
						marker: {
							symbol: 'circle',
							radius: 5,
							states: {
								hover: {
									symbol: 'circle',

									lineColor: 'rgb(100,100,100)',
								},
							},
						},
						states: {
							hover: {
								marker: {
									enabled: false,
								},
							},
						},
						tooltip: {
							positioner: function () {
								return { x: 40, y: 25 }
							},
							headerFormat: '<b>{point.codigoParcela}</b><br>',
							pointFormat:
								'Idade: {point.x:.0f} meses<br>' +
								this.infoGrafico.label +
								': {point.y:.3f} ' +
								this.infoGrafico.unidade.replace('(', '').replace(')', ''),
						},
					},

					series: {
						events: {
							legendItemClick: function (e) {
								e.preventDefault()
							},
						},
						allowPointSelect: true,
						point: {
							events: {
								select: function () {
									// this.parcelasTemporarias.push(this.id)

									this.series.data.find((e) => e.id === this.id).selected = true
									// var text = this.category + ': ' + this.y + ' was last selected'
									// var  chart = this.series.chart;

									// if (!chart.lbl) {
									//     chart.lbl = chart.renderer.label(text, 100, 70)
									//         .attr({
									//             padding: 10,
									//             r: 5,
									//             // fill: Highcharts.getOptions().colors[1],
									//             zIndex: 5
									//         })
									//         .css({
									//             color: '#FFFFFF'
									//         })
									//         .add();
									// } else {
									//     chart.lbl.attr({
									//         text: text
									//     });
									// }
								},
							},
						},
					},
				},

				series: [
					{
						name: 'Parcela',
						showInLegend: false,

						enable: false,
						turboThreshold: Number.MAX_SAFE_INTEGER,
						animation: false,
						// data: this.data.map(e => { return {x: e.idade, y: e.vtcc }})

						data: this.dadosDispersao,
					},
				],
			}
		},

		/**
		 * Prepara os dados para serem plotadas no grafico de dispersao
		 */
		dadosDispersao() {
			return this.series.map((e) => {
				return Object.assign(e, {
					x: Number(e.x.toFixed(3)),
					y: Number(e.y.toFixed(3)),
					color: e.isEstimated ? `rgb(149, 187, 73)` : `#d3d3d3`,
				})
			})
		},

		/**
		 * Configuracao do grafico de acordo com o tipo exibido
		 */
		configuracaoDoGrafico() {
			if (this.dropdownTipoGrafico === 'vtcc') {
				return {
					tipoDoGrafico: 'Volume Total com Casca (m³/ha)',
					titulo: 'Volume Total com Casca por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'vtsc') {
				return {
					tipoDoGrafico: 'Volume Total sem Casca (m³/ha)',
					titulo: 'Volume Total sem Casca por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'alturaDominante') {
				return {
					tipoDoGrafico: 'Altura Dominante',
					titulo: 'Altura Dominante por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'areaBasal') {
				return {
					tipoDoGrafico: 'Área Basal',
					titulo: 'Área Basal por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else {
				return {
					tipoDoGrafico: 'Diâmetro Médio',
					titulo: 'Diâmetro Médio por faixa de idade',
					posicaoDataLabel: -55,
				}
			}
		},
	},
	watch: {
		/**
		 * Tipo do grafico que deve ser mostrado
		 * Área Plantada, Volume ou IMA
		 */
		dropdownTipoGrafico() {
			this.changeHighchartsOptions()
			this.$emit('tipoGrafico', this.dropdownTipoGrafico)
		},
		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.ref__chart.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.ref__chart.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},
	mounted() {
		const rgbDefaultColor = getComputedStyle(document.body).getPropertyValue('--color-default')
		this.chartOptions.series[0].color = `rgb(${rgbDefaultColor})`
	},

	methods: {},
}
</script>

<style scoped>
/* @import url("../../css/tooltipSimplesHighcharts.css"); */
.container__grafico__dispersao {
	display: block;
	flex-direction: column;
	height: 100%;
}

.highcharts-container {
	margin: 0 !important;
	height: 100% !important;
}

#dispersao__parcelas {
	height: 100%;
}
</style>
